// From https://github.com/sooro-io/react-gtm-module/blob/main/src/Snippets.js
import {config} from '../../config.ts';

export type GtmProps = {
    events?: any[];
    dataLayer?: DataLayer;
    dataLayerName?: string;
    auth?: string;
    preview?: string;
    // Loader URL without query: the tagging server decides which container it serves.
    source: string;
};

export type DataLayer = Record<string, any> | undefined;

export const Snippets = {
    tags: function ({
        events = [],
        dataLayer,
        dataLayerName = 'dataLayer',
        auth = undefined,
        preview = undefined,
        source,
    }: GtmProps) {
        const params = new URLSearchParams();
        if (dataLayerName !== 'dataLayer') {
            params.set('l', dataLayerName);
        }
        if (auth && preview) {
            params.set('gtm_auth', auth);
            params.set('gtm_preview', preview);
            params.set('gtm_cookies_win', 'x');
        }
        const query = params.toString();
        const src = query ? `${source}?${query}` : source;

        const script = `
			(function(w,d,s,l){w[l]=w[l]||[];
				w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'}${
                    events!.length > 0
                        ? ',' + JSON.stringify(events).slice(1, -1)
                        : ''
                });
				var f=d.getElementsByTagName(s)[0],j=d.createElement(s);
				j.async=true;
				j.src=${JSON.stringify(src)};
				${config.nonce ? `j.setAttribute('nonce','${config.nonce}');` : ''}
				f.parentNode.insertBefore(j,f);
			})(window,document,'script','${dataLayerName}');`;

        const dataLayerVar = this.dataLayer(dataLayer, dataLayerName!);

        return {
            script,
            dataLayerVar,
        };
    },
    dataLayer: function (dataLayer: DataLayer, dataLayerName: string): string {
        return `
			window.${dataLayerName} = window.${dataLayerName} || [];
			window.${dataLayerName}.push(${JSON.stringify(dataLayer)})`;
    },
};
